import React from "react";
import PropTypes from "prop-types";

import "./ColorCard.scss";

export default class ColorCard extends React.Component {
  render() {
    const { title, color, subtitle, children } = this.props;

    return (
      <div className="colorCard">
        <div
          className="cardTitle"
          style={{
            backgroundColor: color,
            borderRadius: children ? undefined : 5
          }}
        >
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        {children && <div className="cardContent">{children}</div>}
      </div>
    );
  }
}

ColorCard.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  subtitle: PropTypes.string
};
